import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export const ProtectedRoute = ({ children, adminOnly = false, masterOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0F171E' }}>
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2" style={{ borderColor: '#3B82F6' }}></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (masterOnly && user.role !== 'master_admin') {
    return <Navigate to="/" replace />;
  }

  if (adminOnly && user.role !== 'admin' && user.role !== 'master_admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};
